import * as React from "react";
import InputLabel, { inputLabelClasses } from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { SelectItem } from "../../types/global";
import { outlinedInputClasses, SxProps } from "@mui/material";
import { Theme } from "@emotion/react";

type SPSelectProps = {
  items: Array<SelectItem>;
  defaultValue: string | number | undefined;
  onChange: (e: string | number) => void;
  sx?: SxProps<Theme> | undefined;
  bgColor?: string;
  placeholder?: string;
  name?: string;
};

export default function SPSelect({
  sx,
  items,
  onChange,
  defaultValue,
  // size = "medium",
  bgColor,
  placeholder,
  name,
}: SPSelectProps) {
  const handleChange = (event: SelectChangeEvent<string | number>) => {
    onChange(event.target.value);
  };

  return (
    <FormControl sx={{ width: "100%" }}>
      <Select
        labelId="demo-select-small"
        // inputProps={{ "aria-label": "Without label" }}
        displayEmpty
        value={defaultValue}
        onChange={handleChange}
        sx={{
          backgroundColor: bgColor,
          // "& .MuiSelect-select": {
          //   padding: "4px 28px 4px 16px",
          // },
          // borderWidth: '2px',
          textAlign: "right",
          ...sx,
          fontSize: "1.25rem",
          direction: 'rtl'
        }}
        // open={page === name}
      >
        <MenuItem
          value=""
          disabled
          sx={{ fontSize: { md: "1.25rem", xs: "1rem" }, direction: 'rtl' }}
        >
          {placeholder}
        </MenuItem>
        {items.map((item: SelectItem) => (
          <MenuItem
            key={item.value}
            value={item.value}
            sx={{  fontSize: { md: "1.25rem", xs: "1rem" }, direction: 'rtl' }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
